import React from "react";
const VideoPopup = (props, getSectionsGrid) => {
  return (
    <div style={{ height: "200px" }}>
      Exciting updates to our video upload functionality are on the way! Stay
      tuned for the latest enhancements coming soon
    </div>
  );
};
export default VideoPopup;
